import { useDispatch } from 'react-redux';
import { type AppDispatch } from '../../stores/redux';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export type DispatchReturnPromise = Promise<ReturnType<AppDispatch>>;
